import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.object.assign.js";
import _styled from "@emotion/styled/base";
var _excluded = ["children", "desktopNoWrap"];
function cov_2abro87rr() {
  var path = "/__w/code/code/js/packages/cinderblocks/src/platform/auth/shared.tsx";
  var hash = "38fb9a077a04a67d57b095d1a1674ee4cd38c833";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/cinderblocks/src/platform/auth/shared.tsx",
    statementMap: {
      "0": {
        start: {
          line: 20,
          column: 35
        },
        end: {
          line: 20,
          column: 73
        }
      },
      "1": {
        start: {
          line: 22,
          column: 54
        },
        end: {
          line: 32,
          column: 1
        }
      },
      "2": {
        start: {
          line: 23,
          column: 2
        },
        end: {
          line: 31,
          column: 4
        }
      },
      "3": {
        start: {
          line: 39,
          column: 40
        },
        end: {
          line: 43,
          column: 1
        }
      },
      "4": {
        start: {
          line: 40,
          column: 2
        },
        end: {
          line: 43,
          column: 1
        }
      },
      "5": {
        start: {
          line: 45,
          column: 78
        },
        end: {
          line: 48,
          column: 1
        }
      },
      "6": {
        start: {
          line: 47,
          column: 2
        },
        end: {
          line: 47,
          column: 95
        }
      },
      "7": {
        start: {
          line: 50,
          column: 48
        },
        end: {
          line: 52,
          column: 1
        }
      },
      "8": {
        start: {
          line: 51,
          column: 2
        },
        end: {
          line: 51,
          column: 65
        }
      },
      "9": {
        start: {
          line: 54,
          column: 48
        },
        end: {
          line: 56,
          column: 1
        }
      },
      "10": {
        start: {
          line: 55,
          column: 2
        },
        end: {
          line: 55,
          column: 36
        }
      },
      "11": {
        start: {
          line: 58,
          column: 52
        },
        end: {
          line: 60,
          column: 1
        }
      },
      "12": {
        start: {
          line: 59,
          column: 2
        },
        end: {
          line: 59,
          column: 42
        }
      },
      "13": {
        start: {
          line: 62,
          column: 76
        },
        end: {
          line: 92,
          column: 1
        }
      },
      "14": {
        start: {
          line: 67,
          column: 19
        },
        end: {
          line: 67,
          column: 29
        }
      },
      "15": {
        start: {
          line: 68,
          column: 23
        },
        end: {
          line: 68,
          column: 64
        }
      },
      "16": {
        start: {
          line: 69,
          column: 24
        },
        end: {
          line: 69,
          column: 72
        }
      },
      "17": {
        start: {
          line: 70,
          column: 2
        },
        end: {
          line: 78,
          column: 3
        }
      },
      "18": {
        start: {
          line: 71,
          column: 4
        },
        end: {
          line: 77,
          column: 6
        }
      },
      "19": {
        start: {
          line: 80,
          column: 2
        },
        end: {
          line: 91,
          column: 4
        }
      },
      "20": {
        start: {
          line: 94,
          column: 72
        },
        end: {
          line: 127,
          column: 1
        }
      },
      "21": {
        start: {
          line: 95,
          column: 19
        },
        end: {
          line: 95,
          column: 29
        }
      },
      "22": {
        start: {
          line: 96,
          column: 26
        },
        end: {
          line: 99,
          column: 3
        }
      },
      "23": {
        start: {
          line: 100,
          column: 2
        },
        end: {
          line: 126,
          column: 4
        }
      },
      "24": {
        start: {
          line: 130,
          column: 20
        },
        end: {
          line: 133,
          column: 1
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 22,
            column: 54
          },
          end: {
            line: 22,
            column: 55
          }
        },
        loc: {
          start: {
            line: 22,
            column: 65
          },
          end: {
            line: 32,
            column: 1
          }
        },
        line: 22
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 39,
            column: 40
          },
          end: {
            line: 39,
            column: 41
          }
        },
        loc: {
          start: {
            line: 40,
            column: 2
          },
          end: {
            line: 43,
            column: 1
          }
        },
        line: 40
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 45,
            column: 78
          },
          end: {
            line: 45,
            column: 79
          }
        },
        loc: {
          start: {
            line: 45,
            column: 89
          },
          end: {
            line: 48,
            column: 1
          }
        },
        line: 45
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 50,
            column: 48
          },
          end: {
            line: 50,
            column: 49
          }
        },
        loc: {
          start: {
            line: 50,
            column: 59
          },
          end: {
            line: 52,
            column: 1
          }
        },
        line: 50
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 54,
            column: 48
          },
          end: {
            line: 54,
            column: 49
          }
        },
        loc: {
          start: {
            line: 54,
            column: 59
          },
          end: {
            line: 56,
            column: 1
          }
        },
        line: 54
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 58,
            column: 52
          },
          end: {
            line: 58,
            column: 53
          }
        },
        loc: {
          start: {
            line: 58,
            column: 63
          },
          end: {
            line: 60,
            column: 1
          }
        },
        line: 58
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 62,
            column: 76
          },
          end: {
            line: 62,
            column: 77
          }
        },
        loc: {
          start: {
            line: 66,
            column: 6
          },
          end: {
            line: 92,
            column: 1
          }
        },
        line: 66
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 94,
            column: 72
          },
          end: {
            line: 94,
            column: 73
          }
        },
        loc: {
          start: {
            line: 94,
            column: 95
          },
          end: {
            line: 127,
            column: 1
          }
        },
        line: 94
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 64,
            column: 2
          },
          end: {
            line: 64,
            column: 23
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 64,
            column: 18
          },
          end: {
            line: 64,
            column: 23
          }
        }],
        line: 64
      },
      "1": {
        loc: {
          start: {
            line: 69,
            column: 24
          },
          end: {
            line: 69,
            column: 72
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 69,
            column: 53
          },
          end: {
            line: 69,
            column: 61
          }
        }, {
          start: {
            line: 69,
            column: 64
          },
          end: {
            line: 69,
            column: 72
          }
        }],
        line: 69
      },
      "2": {
        loc: {
          start: {
            line: 69,
            column: 24
          },
          end: {
            line: 69,
            column: 50
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 69,
            column: 24
          },
          end: {
            line: 69,
            column: 37
          }
        }, {
          start: {
            line: 69,
            column: 41
          },
          end: {
            line: 69,
            column: 50
          }
        }],
        line: 69
      },
      "3": {
        loc: {
          start: {
            line: 70,
            column: 2
          },
          end: {
            line: 78,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 70,
            column: 2
          },
          end: {
            line: 78,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 70
      },
      "4": {
        loc: {
          start: {
            line: 81,
            column: 13
          },
          end: {
            line: 81,
            column: 37
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 81,
            column: 29
          },
          end: {
            line: 81,
            column: 33
          }
        }, {
          start: {
            line: 81,
            column: 36
          },
          end: {
            line: 81,
            column: 37
          }
        }],
        line: 81
      },
      "5": {
        loc: {
          start: {
            line: 81,
            column: 43
          },
          end: {
            line: 81,
            column: 67
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 81,
            column: 59
          },
          end: {
            line: 81,
            column: 60
          }
        }, {
          start: {
            line: 81,
            column: 63
          },
          end: {
            line: 81,
            column: 67
          }
        }],
        line: 81
      },
      "6": {
        loc: {
          start: {
            line: 86,
            column: 19
          },
          end: {
            line: 86,
            column: 53
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 86,
            column: 35
          },
          end: {
            line: 86,
            column: 41
          }
        }, {
          start: {
            line: 86,
            column: 44
          },
          end: {
            line: 86,
            column: 53
          }
        }],
        line: 86
      },
      "7": {
        loc: {
          start: {
            line: 97,
            column: 11
          },
          end: {
            line: 97,
            column: 57
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 97,
            column: 29
          },
          end: {
            line: 97,
            column: 42
          }
        }, {
          start: {
            line: 97,
            column: 45
          },
          end: {
            line: 97,
            column: 57
          }
        }],
        line: 97
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    b: {
      "0": [0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "38fb9a077a04a67d57b095d1a1674ee4cd38c833"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2abro87rr = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2abro87rr();
import "core-js/modules/es.function.name.js";
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { Text as NovoText } from '@opendoor/bricks-next';
import { Box, Flex, Heading, Link, Text } from '@opendoor/bricks/core';
import { useDevice } from '@opendoor/bricks/hooks/useMedia';
import { useTheme } from '@opendoor/bricks/system/theme';
import { space } from '@opendoor/bricks/theme/eero';
export var INVALID_EMAIL_ERROR = (cov_2abro87rr().s[0]++, "Looks like this isn't a valid email.");
cov_2abro87rr().s[1]++;
export var AccountFormWrapper = function AccountFormWrapper(props) {
  cov_2abro87rr().f[0]++;
  cov_2abro87rr().s[2]++;
  return /*#__PURE__*/React.createElement(Box, _extends({
    width: "100%",
    maxWidth: "500px",
    padding: [7, 7, 0],
    textAlign: ['left', 'left', 'center']
  }, props));
};
cov_2abro87rr().s[3]++;
export var PHONE_DEFAULT_DISCLAIMER = function PHONE_DEFAULT_DISCLAIMER(actionText) {
  cov_2abro87rr().f[1]++;
  cov_2abro87rr().s[4]++;
  return "By clicking \"".concat(actionText, "\" I consent to receive marketing calls and texts from Opendoor\nand its affiliates to the number provided, including by automated means. I may opt out\nat any time and consent is not a condition of purchase.\n");
};
cov_2abro87rr().s[5]++;
export var AccountFormHeader = function AccountFormHeader(props) {
  cov_2abro87rr().f[2]++;
  cov_2abro87rr().s[6]++;
  // eslint-disable-next-line jsx-a11y/heading-has-content
  return /*#__PURE__*/React.createElement(Heading, _extends({
    size: "UNSAFE_h2",
    as: "h2",
    mb: 7,
    fontSize: ['s3', 'UNSAFE_h2']
  }, props));
};
cov_2abro87rr().s[7]++;
export var FormWrapper = function FormWrapper(props) {
  cov_2abro87rr().f[3]++;
  cov_2abro87rr().s[8]++;
  return /*#__PURE__*/React.createElement(Flex, _extends({
    width: "100%",
    flexDirection: "column"
  }, props));
};
cov_2abro87rr().s[9]++;
export var BodyWrapper = function BodyWrapper(props) {
  cov_2abro87rr().f[4]++;
  cov_2abro87rr().s[10]++;
  return /*#__PURE__*/React.createElement(Text, _extends({
    my: 2
  }, props));
};
cov_2abro87rr().s[11]++;
export var CtaButtonWrapper = function CtaButtonWrapper(props) {
  cov_2abro87rr().f[5]++;
  cov_2abro87rr().s[12]++;
  return /*#__PURE__*/React.createElement(Box, _extends({
    mt: 9,
    mb: 5
  }, props));
};
cov_2abro87rr().s[13]++;
export var Disclaimer = function Disclaimer(_ref) {
  var children = _ref.children,
    _ref$desktopNoWrap = _ref.desktopNoWrap,
    desktopNoWrap = _ref$desktopNoWrap === void 0 ? (cov_2abro87rr().b[0][0]++, false) : _ref$desktopNoWrap,
    props = _objectWithoutProperties(_ref, _excluded);
  cov_2abro87rr().f[6]++;
  var _ref2 = (cov_2abro87rr().s[14]++, useTheme()),
    name = _ref2.name;
  var _ref3 = (cov_2abro87rr().s[15]++, useDevice({
      reevaluateAfterMount: true
    })),
    isMobile = _ref3.isMobile;
  var whiteSpaceCSS = (cov_2abro87rr().s[16]++, (cov_2abro87rr().b[2][0]++, desktopNoWrap) && (cov_2abro87rr().b[2][1]++, !isMobile) ? (cov_2abro87rr().b[1][0]++, 'nowrap') : (cov_2abro87rr().b[1][1]++, 'normal'));
  cov_2abro87rr().s[17]++;
  if (name == 'novo') {
    cov_2abro87rr().b[3][0]++;
    cov_2abro87rr().s[18]++;
    return /*#__PURE__*/React.createElement(Box, props, /*#__PURE__*/React.createElement(NovoText, {
      tag: "p",
      typography: "$bodyXsmall",
      whiteSpace: whiteSpaceCSS
    }, children));
  } else {
    cov_2abro87rr().b[3][1]++;
  }
  cov_2abro87rr().s[19]++;
  return /*#__PURE__*/React.createElement(Box, _extends({
    mt: desktopNoWrap ? (cov_2abro87rr().b[4][0]++, null) : (cov_2abro87rr().b[4][1]++, 9),
    mb: desktopNoWrap ? (cov_2abro87rr().b[5][0]++, 9) : (cov_2abro87rr().b[5][1]++, null)
  }, props), /*#__PURE__*/React.createElement(Text, {
    size: "80",
    color: "neutrals90",
    whiteSpace: whiteSpaceCSS,
    textAlign: desktopNoWrap ? (cov_2abro87rr().b[6][0]++, 'left') : (cov_2abro87rr().b[6][1]++, 'inherit')
  }, children));
};
cov_2abro87rr().s[20]++;
export var EmailDisclaimerText = function EmailDisclaimerText(_ref4) {
  var analyticsName = _ref4.analyticsName;
  cov_2abro87rr().f[7]++;
  var _ref5 = (cov_2abro87rr().s[21]++, useTheme()),
    name = _ref5.name;
  var linkTextStyling = (cov_2abro87rr().s[22]++, {
    color: name === 'novo' ? (cov_2abro87rr().b[7][0]++, 'warmgrey900') : (cov_2abro87rr().b[7][1]++, 'neutrals90'),
    textDecoration: 'underline'
  });
  cov_2abro87rr().s[23]++;
  return /*#__PURE__*/React.createElement(Disclaimer, {
    desktopNoWrap: true
  }, "By clicking \u201CContinue,\u201D you agree to Opendoor's and its affiliates\u2019\xA0", /*#__PURE__*/React.createElement(Link, {
    href: "https://www.opendoor.com/terms",
    display: "inline",
    target: "_blank",
    analyticsName: "".concat(analyticsName, "-terms"),
    "aria-label": "Opens a new page with Opendoor's terms of service",
    __css: linkTextStyling
  }, "Terms of Service"), "\xA0and\xA0", /*#__PURE__*/React.createElement(Link, {
    href: "https://www.opendoor.com/privacy",
    display: "inline",
    target: "_blank",
    analyticsName: "".concat(analyticsName, "-privacy-policy"),
    "aria-label": "Opens a new page with Opendoor's privacy policy",
    __css: linkTextStyling
  }, "Privacy Policy"), ".");
};

// eslint-disable-next-line no-restricted-syntax
export var Form = (cov_2abro87rr().s[24]++, /*#__PURE__*/_styled("form", process.env.NODE_ENV === "production" ? {
  target: "e1a669rm0"
} : {
  target: "e1a669rm0",
  label: "Form"
})("width:100%;margin-top:", space[7], ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")));
//# sourceMappingURL=shared.mjs.map